import {dataProvider} from "../../../utils/data-provider";
import {ShortWineDto, SuggestListWineDto} from "../../../types/wine";

const apiUrl = '/admin/wine-suggestions'
export async function fetchSearch(q: string) {
  const { data } = await dataProvider.customMethod(`${apiUrl}/search?q=${encodeURIComponent(q)}`, { method: 'GET' });
  return data as ShortWineDto[];
}

export async function fetchList() {
  const { data } = await dataProvider.customMethod(`${apiUrl}/list`, { method: 'GET' });
  return data as SuggestListWineDto;
}

export async function addToList(wineId: string) {
  return dataProvider.customMethod(`${apiUrl}/list`, {
    method: 'POST',
    body: JSON.stringify({ wineId }),
    headers: new Headers({ 'Content-Type': 'application/json' }),
  });
}

export async function removeFromList(wineId: string) {
  return dataProvider.customMethod(`${apiUrl}/list/${wineId}`, { method: 'DELETE' });
}
